import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InboxRoutes } from './inbox.routes';
import { InboxListComponent } from './pages/inbox-list/inbox-list.component';

const ROUTES: Routes = [{ path: InboxRoutes.InboxList, component: InboxListComponent }];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class InboxRoutingModule {}
